import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Modal,
  TextField,
  MenuItem,
  Pagination,
} from "@mui/material";
import { Edit, Preview, Delete } from "@mui/icons-material";
import {
  useCreatenewShortLinkMutation,
  useDeleteshortLinkMutation,
  useGetHeadersQuery,
  useGetshortLinkQuery,
} from "../store/services/shortLinkApi";
import { toast } from "react-toastify";
import { cellSX, layoutCSS } from "../component/common/commonStyle";

const ShortLink = () => {
  const [open, setOpen] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [linkName, setLinkName] = useState("");
  const [linkType, setLinkType] = useState("website");
  const [linkUrl, setLinkUrl] = useState("");
  const [file, setFile] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [deleteShortLink] = useDeleteshortLinkMutation();
  const { data: headerData } = useGetHeadersQuery();
  const headers = headerData?.data || [];
  const [errors, setErrors] = useState({});
  const [selectedHeader, setSelectedHeader] = useState("");
  const {
    data: getAllShortLink,
    error,
    isLoading,
    refetch: refetchShortLink,
  } = useGetshortLinkQuery({ page, limit: pageSize });

  const [createShortLink] = useCreatenewShortLinkMutation();
  const rows = getAllShortLink?.data ?? [];
  const total =
    getAllShortLink?.total_records ??
    getAllShortLink?.total ??
    getAllShortLink?.count ??
    rows.length;

  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = total === 0 ? 0 : Math.min(page * pageSize, total);
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  console.log({ getAllShortLink: getAllShortLink?.data });

  const [formData, setFormData] = useState({
    name: "",
    type: "Website",
    entity: "",
    senderId: "",
    url: "",
  });
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrors({});
  };
  const handleBulkUploadClose = () => setBulkUploadOpen(false);

  const handleDelete = async (id) => {
    try {
      const response = await deleteShortLink({ short_link_id: id });
      console.log({ response });

      if (response?.data?.status) {
        toast.success("Short link deleted successfully!");
        refetchShortLink();
        console.log("Short link deleted successfully!");
      } else {
        console.log(response.message || "Failed to delete short link");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error(
        error.data?.message || error.message || "Error deleting short link",
      );
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    const newErrors = {};

    if (!linkName.trim()) {
      newErrors.linkName = "Short Link Name is required";
    }

    if (!linkType) {
      newErrors.linkType = "Link Type is required";
    }

    if (linkType === "website") {
      if (!selectedHeader) {
        newErrors.selectedHeader = "Header is required";
      }

      if (!linkUrl.trim()) {
        newErrors.linkUrl = "URL is required";
      }
    }

    if (linkType === "document" || linkType === "image") {
      if (!file) {
        newErrors.file = "File is required";
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all mandatory fields");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("name", linkName);
      formData.append("link_type", linkType);
      formData.append("original_link", linkUrl);
      formData.append("header_name", selectedHeader); // 👈 added

      if (file) {
        formData.append("image", file);
      }

      const res = await createShortLink(formData);

      if (res?.data?.status) {
        toast.success("Short link created successfully!");
        refetchShortLink();
        setLinkName("");
        setLinkType("website");
        setLinkUrl("");
        setSelectedHeader(""); // reset
        setFile(null);
      }
      setErrors({});
      handleClose();
    } catch (error) {
      toast.error("Error creating short link: " + error.message);
    }
  };
  const inputSx = {
    borderRadius: "0.5rem",
    minWidth: 140,
    "& .MuiOutlinedInput-root": {
      background: "rgba(255,255,255,0.7)",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#94A3B8" },
    },
    "& .MuiInputLabel-root": { color: "#475569" },
    "& .Mui-disabled": {
      "& .MuiOutlinedInput-input": {
        color: "#334155 !important",
        WebkitTextFillColor: "#334155 !important",
      },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
    },
  };
  return (
    <Box sx={layoutCSS}>
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "0.9rem",
              fontWeight: "bold",
            }}
          >
            Manage Short Link
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: "0.75rem", textTransform: "none", mb: 2 }}
            onClick={handleOpen}
          >
            Create New{" "}
          </Button>
        </Box>
        {/* Table */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                bgcolor: "#0288d1",
                "& th": {
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "0.75rem",
                  borderBottom: "0.5px solid #B0B0B0",
                  padding: "8px",
                  borderRight: "0.5px solid #B0B0B0",
                },
              }}
            >
              <TableRow>
                <TableCell>Short Link ID</TableCell>
                <TableCell>Short Link Name</TableCell>
                <TableCell>Short Link Type</TableCell>
                <TableCell>Short Link URL</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "& td": {
                      borderRight: "0.5px solid #B0B0B0",
                      borderBottom: "0.5px solid #B0B0B0",
                      padding: "8px",
                    },
                  }}
                >
                  <TableCell sx={cellSX}>{data.short_link_id}</TableCell>
                  <TableCell sx={cellSX}>{data.name}</TableCell>
                  <TableCell sx={cellSX}>{data.link_type}</TableCell>
                  <TableCell sx={cellSX}>{data.short_link}</TableCell>
                  <TableCell
                    sx={{
                      "& .MuiButton-root": {
                        minWidth: "40px",
                        padding: "4px",
                      },
                    }}
                  >
                    <Button
                      variant="text"
                      color="secondary"
                      startIcon={<Preview />}
                      onClick={() => {
                        window.open(data.original_link, "_blank");
                      }}
                    ></Button>
                    <Button
                      variant="text"
                      color="error"
                      onClick={() => handleDelete(data.short_link_id)}
                      startIcon={<Delete />}
                    ></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Typography sx={{ fontSize: "0.75rem" }} variant="body2">
            Showing {from} to {to} of {total} Records
          </Typography>

          <Pagination
            count={pageCount}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />

          <Pagination count={1} color="primary" />
        </Box>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "rgba(255, 255, 255, 0.16)",
            backdropFilter: "blur(10px)",
            borderRadius: 0.5,
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontSize: "0.9rem" }}>
            Generate New Short Link
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Short Link Name"
                variant="outlined"
                size="small"
                name="name"
                value={linkName}
                onChange={(e) => {
                  setLinkName(e.target.value);
                  setErrors((prev) => ({ ...prev, linkName: "" }));
                }}
                error={Boolean(errors.linkName)}
                helperText={errors.linkName}
                required
                sx={inputSx}
                slotProps={{ textField: { size: "small" } }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                select
                label="Select Link Type"
                variant="outlined"
                size="small"
                name="type"
                value={linkType}
                // onChange={(e) => setLinkType(e.target.value)}
                onChange={(e) => {
                  setLinkType(e.target.value);
                  setErrors({});
                  setLinkUrl("");
                  setSelectedHeader("");
                  setFile(null);
                }}
                error={Boolean(errors.linkType)}
                helperText={errors.linkType}
                required
                sx={inputSx}
                slotProps={{ textField: { size: "small" } }}
              >
                <MenuItem value="website" sx={{ fontSize: "0.75rem", py: 0.5 }}>
                  Website
                </MenuItem>
                <MenuItem
                  value="document"
                  sx={{ fontSize: "0.75rem", py: 0.5 }}
                >
                  Pdf
                </MenuItem>
                <MenuItem value="image" sx={{ fontSize: "0.75rem", py: 0.5 }}>
                  Image
                </MenuItem>
              </TextField>
            </Grid>
            {linkType === "website" && (
              <>
                {/* Header Dropdown */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    select
                    label="Select Header"
                    size="small"
                    value={selectedHeader}
                    onChange={(e) => {
                      setSelectedHeader(e.target.value);
                      setErrors((prev) => ({ ...prev, selectedHeader: "" }));
                    }}
                    error={Boolean(errors.selectedHeader)}
                    helperText={errors.selectedHeader}
                    required
                    sx={inputSx}
                    slotProps={{ textField: { size: "small" } }}
                  >
                    {headers.map((item) => (
                      <MenuItem
                        key={item.header_id}
                        value={item.header_name}
                        sx={{ fontSize: "0.75rem" }}
                      >
                        {item.header_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* URL Input */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Enter URL"
                    variant="outlined"
                    size="small"
                    value={linkUrl}
                    onChange={(e) => {
                      setLinkUrl(e.target.value);
                      setErrors((prev) => ({ ...prev, linkUrl: "" }));
                    }}
                    error={Boolean(errors.linkUrl)}
                    helperText={errors.linkUrl}
                    required
                    placeholder="Ex. http://www.xyz.com"
                    sx={inputSx}
                    slotProps={{ textField: { size: "small" } }}
                  />
                </Grid>
              </>
            )}
            {(linkType === "document" || linkType === "image") && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="file"
                  size="small"
                  name="file"
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                    setErrors((prev) => ({ ...prev, file: "" }));
                  }}
                  error={Boolean(errors.file)}
                  helperText={errors.file}
                  required
                  sx={inputSx}
                  slotProps={{ textField: { size: "small" } }}
                />
              </Grid>
            )}
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{ ml: 2, fontSize: "0.7rem" }}
              onClick={handleSave}
            >
              Save Changes
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ ml: 2, fontSize: "0.7rem" }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={bulkUploadOpen} onClose={handleBulkUploadClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}
          >
            Bulk Upload
          </Typography>
          <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
            Please upload a CSV file with the following column sequence:
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 3, fontStyle: "italic" }}
          >
            LinkName, SenderID, URL
          </Typography>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              size="small"
              placeholder="No file chosen"
              InputProps={{
                endAdornment: (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500 }}
                    ></Typography>
                    <Button
                      component="label"
                      sx={{
                        fontSize: "0.875rem",
                        textTransform: "none",
                        color: "primary.main",
                        textDecoration: "underline",
                        cursor: "pointer",
                        ":hover": { textDecoration: "none" },
                      }}
                    >
                      Browse
                      <input type="file" hidden />
                    </Button>
                  </Box>
                ),
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button variant="contained" color="primary">
              Upload
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={handleBulkUploadClose}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ShortLink;
